module.exports = __webpack_public_path__ + "fonts/38ab41f9bb03994e014e1b8a66de32f7.svg";